/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Rule = {
  properties: {
    rule: {
      type: 'string',
      isRequired: true,
    },
    score: {
      type: 'number',
      isRequired: true,
    },
    evidences: {
      type: 'array',
      contains: {
        type: 'string',
      },
      isRequired: true,
    },
  },
} as const;
